import dayjs from "dayjs";

export function toDateString(date: string | number) {
  return dayjs(date).format("YYYY/MM/DD HH:mm");
}
